module.exports = __webpack_public_path__ + "img/smiling-face-with-horns.bc71ded2.png";